module.exports = __webpack_public_path__ + "static/media/Assets-02-HRA-halftone.ebc3fd97.png";